import { render, staticRenderFns } from "./DirectMembers.vue?vue&type=template&id=18e09525&scoped=true"
import script from "./DirectMembers.vue?vue&type=script&lang=js"
export * from "./DirectMembers.vue?vue&type=script&lang=js"
import style0 from "./DirectMembers.vue?vue&type=style&index=0&id=18e09525&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e09525",
  null
  
)

export default component.exports